<template>
  <div class="content">
    <h1>Dag 4</h1>
    <h2>I dag skal I:</h2>
    <ul
      style="width: 25%; margin: 0px auto; text-align: left; margin-bottom: 20px;"
    >
      <li>Forberede en præsentation af jeres spil!</li>
      <li>Færdiggøre jeres spil!</li>
      <li>Præsentere jeres spil for klassen!</li>
    </ul>
    <br />

    <h3>TIL KODEREN:</h3>
    <p>
      Start med at teste jeres spil og find ud af, hvad I mangler, for at det er
      helt færdigt. <br />
      Når spillet er færdigt kan I overveje, hvad I kan tilføje, for at gøre det
      endnu bedre. <br />
      <br />
      <strong>Forslag:</strong>
    </p>
    <ul class="sugs">
      <li>Vinder-skærm.</li>
      <li>Game over-skærm.</li>
      <li>
        Lyd. Evt. lyd når spillet starter, lyd når der sker noget specifikt i
        spillet, eller andet.
      </li>
      <li>Start-skærm. Evt. med forklaring af hvordan man spiller spillet.</li>
    </ul>
    <p>
      Når spillet er helt færdigt, så husk at give det et navn, og trykke på
      ‘Share’-knappen. <br />
      <br />
      <img
        src="/static/images/learning/dag4/share_button.svg"
        style="width: 100px;"
      />

      <br />
      Dermed kan andre prøve jeres spil, hvis I deler linket. <br />
    </p>
    <br />
    <br />

    <h3>TIL TEGNEREN:</h3>

    <p>
      Imens din makker gør spillet helt færdigt, skal du forberede
      præsentationen i Google Slides.
    </p>
    <br />
    <br />
    <h3>Præsentationen skal indeholde:</h3>

    <img src="/static/images/presentation_cco.png" style="width: 800px;" />
    <br />

    <p>Når både spillet og præsentationen er færdige, skal I øve jer.</p>
    <br />
    <h3>Nu er I klar til at præsentere for klassen!</h3>

    <br />
    <h2>Held og lykke!</h2>
  </div>
</template>

<script>
import EmbedScratch from "@/components/ScratchEmbed";
export default {
  name: "Day2",
  components: {
    EmbedScratch
  }
};
</script>

<style>
.sugs {
  width: 25%;
  margin: 0px auto;
  text-align: left;
  margin-bottom: 20px;
}
.sugs li {
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/undervisning/dag-4.vue